var a = /\w*$/;
function e(t) {
  var n = new t.constructor(t.source, a.exec(t));
  return n.lastIndex = t.lastIndex, n;
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_cloneRegExp.js
// module id = 1499
// module chunks = 67